import MockAdapter from 'axios-mock-adapter/types'

export function mockAccount(mocker: MockAdapter) {
  mocker.onGet(RegExp('^/users/token/')).reply((config) => {
    return [
      200,
      {
        code: 200,
        data: {
          userId: 20020,
          accountId: 0,
          layer2Id: 214,
          address: '0x3498F456645270eE003441df82C718b56c0e6666',
          layer2Address: '0xc8354db44ef101260b70bdce29b163571bea33a8',
          pubKey:
            '0xa019914b6f96f2c63d440157932cea2df50b2cadb8c65e07868e4be3332990a6',
          status: 3,
          organizationId: 0,
          type: null,
          level: 0,
          internal: false,
          canSignin: true,
          canTransfer: true,
          canTrade: true,
          canWithdraw: true,
          authToken:
            'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIweDM0OThGNDU2NjQ1MjcwZUUwMDM0NDFkZjgyQzcxOGI1NmMwZTY2NjYiLCJpc3MiOiJJU1NVRVIiLCJleHAiOjE3MDYwNzY3MzV9.J4N-8o4zj8YA72XIX9WRqIKrXfs962_4tIiVUdmJubc',
          createdAt: 1705044777605,
          updatedAt: 1705044863183,
        },
      },
    ]
  })
}
